import { useRef } from "react";
import { useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";

interface IProps {
  enableDamping?: boolean;
}

export default function AppControls({ enableDamping = true }: IProps) {
  const { camera } = useThree();
  const ref = useRef<any>();

  return (
    <OrbitControls
      camera={camera}
      ref={ref}
      enableZoom={false}
      enableDamping={enableDamping}
      makeDefault
      dampingFactor={enableDamping ? 0.1 : 0}
      rotateSpeed={-0.5}
    />
  );
}
